import { getAxios } from "util/xhr";
import { SEND_SMS_API_URL } from "../routes/apiRoutes";

export function sendSMSMessage(mobilePhoneNumber) {
  return getAxios().post(
    SEND_SMS_API_URL,
    JSON.stringify({
      mobile_phone: mobilePhoneNumber,
      link_type: "client_app",
    })
  );
}
